import React, { useState } from 'react';
import { GlassPage } from '../components/chrome';
import { postJSON } from '../lib/api';

const CheckIcon = ({ size = 18, className }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className={className} xmlns="http://www.w3.org/2000/svg">
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

const Purchase = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [touched, setTouched] = useState(false);
  const [joined, setJoined] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(false);

  const emailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  const nameValid = name.trim().length > 0;

  const handleJoin = async (e) => {
    e.preventDefault();
    setTouched(true);
    if (!nameValid || !emailValid || submitting) return;

    setSubmitting(true);
    setError(false);
    try {
      // Waitlist signups go through the existing /contact route, tagged so
      // they're easy to spot among regular contact submissions.
      await postJSON('/contact', {
        name: name.trim(),
        email,
        organization: 'Waitlist',
        message: 'Waitlist signup. Send a promo code at launch.',
      });
      setJoined(true);
    } catch (err) {
      console.error(err);
      setError(true);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <GlassPage>
      <div className="max-w-lg mx-auto px-4 md:px-6 pt-28 md:pt-36">
        {/* Waitlist panel */}
        <section className="glass px-8 md:px-12 py-12 md:py-16">
          <div className="w-full max-w-md mx-auto">
            {!joined ? (
              <form onSubmit={handleJoin} className="space-y-8">
                <div>
                  <h2 className="text-2xl md:text-3xl font-bold tracking-tighter uppercase mb-2 text-zinc-900">Coming soon</h2>
                  <p className="text-sm text-zinc-500">
                    Help us by joining the waitlist.
                  </p>
                  <p className="text-sm font-semibold text-zinc-900 mt-1">
                    Receive a promo-code at launch.
                  </p>
                </div>

                <div>
                  <label htmlFor="name" className="block text-[10px] font-bold uppercase tracking-widest text-zinc-400 mb-3">
                    Name
                  </label>
                  <input
                    id="name"
                    type="text"
                    name="name"
                    autoComplete="name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    placeholder="Your name"
                    className={`glass-input w-full px-6 py-4 ${touched && !nameValid ? 'border-red-400' : ''}`}
                  />
                </div>

                <div>
                  <label htmlFor="email" className="block text-[10px] font-bold uppercase tracking-widest text-zinc-400 mb-3">
                    Email
                  </label>
                  <input
                    id="email"
                    type="email"
                    name="email"
                    autoComplete="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="you@email.com"
                    className={`glass-input w-full px-6 py-4 ${touched && !emailValid ? 'border-red-400' : ''}`}
                  />
                  {touched && !emailValid && (
                    <p className="mt-2 text-[10px] uppercase tracking-widest text-red-500 font-bold">Enter a valid email</p>
                  )}
                </div>

                <button type="submit" disabled={submitting} className={`btn-dark group w-full py-5 ${submitting ? 'opacity-60 cursor-wait' : ''}`}>
                  {submitting ? 'Joining...' : 'Join Waitlist'}
                  {!submitting && <span className="transition-transform duration-300 group-hover:translate-x-1">→</span>}
                </button>

                {error && (
                  <p className="text-center text-[10px] uppercase tracking-widest text-red-500 font-bold">
                    Something went wrong. Please try again.
                  </p>
                )}

                <p className="text-center text-[10px] uppercase tracking-widest text-zinc-900 font-bold">No spam ever</p>
              </form>
            ) : (
              <div className="space-y-8 text-center">
                <div className="mx-auto w-16 h-16 rounded-full border border-green-500/30 bg-green-500/10 flex items-center justify-center text-green-600">
                  <CheckIcon size={28} />
                </div>
                <div>
                  <h2 className="text-3xl font-bold tracking-tighter uppercase mb-3 text-zinc-900">You're on the list</h2>
                  <p className="text-sm text-zinc-500 leading-relaxed">
                    Thanks, <span className="text-zinc-900 font-bold">{name.trim().split(' ')[0]}</span>. We'll email{' '}
                    <span className="text-zinc-900">{email}</span> the moment orders open.
                  </p>
                </div>
              </div>
            )}
          </div>
        </section>
      </div>
    </GlassPage>
  );
};

export default Purchase;
